export const validFechaRegex = RegExp(
  /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i,
);

export const validEmailRegex = RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);
//export const validEmailRegex = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export const validTextoRegex = RegExp(/^[a-zñäáàëéèíìöóòúùñA-ZÄÁÀËÉÈÍÌÖÓÒÚÙÑ\s.,]*$/i);
//export const validTextoRegex = RegExp(/^[a-zäáàëéèíìöóòúùñA-ZÄÁÀËÉÈÍÌÖÓÒÚÙÑ\s\.\,]*$/i);

export const validNombres = RegExp(/^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\s]+$/);
export const validDirecciones = RegExp(/^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\s0-9-.]+$/);

//export const validDecimales = RegExp(/^[0-9]+([.][0-9]+)?$/)

export const validDecimales = RegExp(/^(\d+\.?\d{0,9}|\.\d{1,9})$/);

export const validEnterosRegex = RegExp(/^[0-9\b]+$/);

export const validPlacaRegex = RegExp(/[A-Z]{3}[0-9]{4}$/);

export function validarRuc(numero) {
  // numero = campo.value;
  let residuo = 0;
  let modulo = 10;
  const d3 = parseInt(numero.substring(2, 3));
  const pub = d3 === 6 ? true : false;
  const pri = d3 === 9 ? true : false;
  if (d3 === 7 || d3 === 8) {
    // alert('El tercer dígito ingresado es inválido');
    return false;
  }
  const pernat = '212121212';
  const sociep = '327654320';
  const privad = '432765432';
  let suma = 0;

  for (let i = 0; i < 9; i++) {
    const n = parseInt(numero.substring(i, i + 1));
    let m = parseInt(pernat.substring(i, i + 1));
    let a = n * m;
    if (a > 9) a = a - 9;
    if (pub) {
      m = parseInt(sociep.substring(i, i + 1));
      a = n * m;
    } else if (pri) {
      m = parseInt(privad.substring(i, i + 1));
      a = n * m;
    }
    suma = suma + a;
  }

  if (pub || pri) modulo = 11;
  residuo = suma % modulo;
  // Si residuo=0, dig.ver.=0, caso contrario 10 - residuo//
  let digitoVerificador = residuo === 0 ? 0 : modulo - residuo;
  // ahora comparamos el elemento de la posicion 10 con el dig. ver.
  if (pub === true) {
    if (digitoVerificador !== parseInt(numero.substring(8, 9))) {
      return validarCedulaExtranjero(numero);
      //return false;
    }
    // El ruc de las empresas del sector publico terminan con 0001
    if (parseInt(numero.substr(9, 4)) === 0) return false;
  } else {
    if (digitoVerificador !== parseInt(numero.substring(9, 10))) return false;
    if (pri && parseInt(numero.substring(10) <= 0)) return false;
  }
  return true;
}

const validarCedulaExtranjero = (numero) => {
  const d3 = parseInt(numero.substring(2, 3));
  if (d3 === 7 || d3 === 8) return false;
  const pernat = '212121212';
  let suma = 0;
  for (let i = 0; i < 9; i++) {
    const n = parseInt(numero.substring(i, i + 1));
    const m = parseInt(pernat.substring(i, i + 1));
    let a = n * m;
    if (a > 9) a = a - 9;
    suma = suma + a;
  }
  const modulo = 10;
  const residuo = suma % modulo;
  const digitoVerificador = residuo === 0 ? 0 : modulo - residuo;
  if (digitoVerificador !== parseInt(numero.substring(9, 10))) return false;
  return true;
};
export const soloLetras = (e) => {
  let key = e.keyCode || e.which;
  let tecla = String.fromCharCode(key).toLowerCase();
  let letras = ' áéíóúabcdefghijklmnñopqrstuvwxyz';
  let especiales = '8-37-39-46';

  let tecla_especial = false;

  for (var i in especiales) {
    if (key === especiales[i]) {
      tecla_especial = true;
      break;
    }
  }

  if (letras.indexOf(tecla) === -1 && !tecla_especial) {
    return false;
  }

  return true;
};
